import { useEffect, useState } from "react";
import api from "@/lib/api";
import { rupiah, MONTHS_ID } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { TrendingUp, CalendarCheck } from "lucide-react";
import { ResponsiveContainer, BarChart, Bar, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";

const shortMonth = (m) => { const [y, mo] = m.split("-"); return `${MONTHS_ID[Number(mo) - 1].slice(0, 3)} '${y.slice(2)}`; };

export function TrendCharts() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/dashboard/trends", { params: { months: 6 } }).then((r) => setData(r.data.map((d) => ({ ...d, label: shortMonth(d.month) }))));
  }, []);
  if (!data) return null;

  return (
    <div className="grid grid-cols-1 gap-4">
      <Card className="p-6 rounded-2xl border-amber-100" data-testid="trend-payment-chart">
        <div className="flex items-center gap-2 mb-4">
          <TrendingUp className="w-5 h-5 text-emerald-600" />
          <h3 className="font-display text-xl font-bold text-slate-900">Tren Pemasukan Iuran</h3>
        </div>
        <div className="h-60">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ left: 8, right: 8 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#fde68a" vertical={false} />
              <XAxis dataKey="label" tick={{ fontSize: 12, fill: "#64748b" }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fontSize: 11, fill: "#94a3b8" }} axisLine={false} tickLine={false} tickFormatter={(v) => `${Math.round(v / 1000)}k`} width={40} />
              <Tooltip formatter={(v, n) => [rupiah(v), n === "collected" ? "Terkumpul" : "Target"]} contentStyle={{ borderRadius: 12, borderColor: "#fcd34d" }} />
              <Bar dataKey="target" fill="#fde68a" radius={[8, 8, 0, 0]} />
              <Bar dataKey="collected" fill="#f97316" radius={[8, 8, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Card>

      <Card className="p-6 rounded-2xl border-amber-100" data-testid="trend-attendance-chart">
        <div className="flex items-center gap-2 mb-4">
          <CalendarCheck className="w-5 h-5 text-sky-600" />
          <h3 className="font-display text-xl font-bold text-slate-900">Tren Kehadiran (%)</h3>
        </div>
        <div className="h-60">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ left: 8, right: 8 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#bae6fd" vertical={false} />
              <XAxis dataKey="label" tick={{ fontSize: 12, fill: "#64748b" }} axisLine={false} tickLine={false} />
              <YAxis domain={[0, 100]} tick={{ fontSize: 11, fill: "#94a3b8" }} axisLine={false} tickLine={false} width={32} />
              <Tooltip formatter={(v, n, p) => [`${v}% (${p.payload.hadir}/${p.payload.total_sesi} sesi)`, "Kehadiran"]} contentStyle={{ borderRadius: 12, borderColor: "#7dd3fc" }} />
              <Line type="monotone" dataKey="attendance_pct" stroke="#0ea5e9" strokeWidth={3} dot={{ r: 5, fill: "#0ea5e9", strokeWidth: 2, stroke: "#fff" }} activeDot={{ r: 7 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </Card>
    </div>
  );
}
